import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa } from '../../../shared/api-visa.model';

@Injectable({ providedIn: 'root' })
export class AlgChannelService {
  protected apiUrl: string;
  protected endpointPath: string;
  protected httpClient: HttpClient;

  constructor() {}

  public getHttpHeader(apiVisa: ApiVisa) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'tenantCode': apiVisa.tenantCode,
        'Authorization': apiVisa.jwt_secret,
      })
    };
    return httpOptions;
  }

  public getMultiPartFormHttpHeader(apiVisa: ApiVisa) {
    const httpOptions = {
      headers: new HttpHeaders({
        'tenantCode': apiVisa.tenantCode,
        'Authorization': apiVisa.jwt_secret,
      })
    };
    return httpOptions;
  }

  public setApiUrl(apiVisa: ApiVisa) {
    if (this.endpointPath && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpointPath;
    }
  }

  public sendMessage(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    return this.httpClient.post(this.apiUrl, data, this.getHttpHeader(apiVisa));
  }

  public sendMessageOutbound(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/outbound';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendAttachmentMessage(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/media';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

  public sendAttachmentMessageOutbound(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/media/outbound';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

  public initiateConversation(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl.replace('send', 'new-conversation');
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public initiateConversationOutbound(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl.replace('send', 'new-conversation/outbound');
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendNewMessage(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/new';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendNewAttachmentMessage(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/media/new';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

  public sendBroadcast(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/broadcast';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendTemplateMessage(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl + '/template';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendNewEmail(data: any, apiVisa: ApiVisa) {
    const url = this.apiUrl + '/new-email';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }

  public sendNewAttachmentEmail(data: FormData, apiVisa: ApiVisa) {
    console.log('data', data);
    const url = this.apiUrl + '/media/new-email';
    return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
  }


}
